import React, { useState } from 'react';

interface CheckboxProps {
  onChange: ( value: boolean ) => void;
  defaultChecked?: boolean;
  label: string;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = ( { onChange, defaultChecked = false, label, className = 'w-full space-x-2', labelClassName = 'w-40', disabled = false } ) => {
  const [ isChecked, setIsChecked ] = useState( defaultChecked );

  const handleChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {
    const newCheckedValue = event.target.checked;
    setIsChecked( newCheckedValue );
    onChange( newCheckedValue );
  };

  return (
    <div className={`flex items-center ${className}`}>
      <p className={`text-gray-600 ${labelClassName}`}>{label}</p>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className={ `w-5 h-5 text-app-color   border-gray-300 rounded focus:ring-2 focus:ring-app-color ${ disabled ? 'cursor-not-allowed' : 'cursor-pointer' }` }
        disabled={disabled}
        name={label}
      />
    </div>
  );
};

export default Checkbox;
